"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkHBRSM4ERjs = require('./chunk-HBRSM4ER.js');var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react3 = require('@emotion/react');var _jsxruntime = require('react/jsx-runtime');function v({children:e}){return e}var x=(e,t)=>e==="large"?t.measurements.spacing(7):t.measurements.spacing(6),I=(e,t)=>e==="large"?t.measurements.spacing(10):t.measurements.spacing(8),m=_react3.css`
  display: inline-flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
`,_=_styled2.default.span`
  display: inline-flex;
  align-items: center;
`,F=_styled2.default.call(void 0, _chunkHBRSM4ERjs.a)`
  margin-top: ${e=>e.theme.measurements.spacing(.5)};
  margin-left: ${e=>e.theme.measurements.spacing(.25)};
  display: inline-block;
  transition: 0.35s;

  .arrow-line,
  .arrow-pointer {
    transition: 0.35s;
    fill: ${e=>e.theme.palette.BASE_FILL};
  }
`,T=_styled2.default.a`
  ${m}
  color: ${e=>e.theme.palette.BASE_FILL};
  text-decoration: ${e=>e.$underline?"underline":"none"};
  text-decoration-color: ${e=>e.$underline?e.theme.palette.BASE_FILL:"transparent"};
  font-size: ${e=>x(e.$size,e.theme)};
  line-height: ${e=>I(e.$size,e.theme)};
  font-weight: 600;
  pointer-events: ${e=>e.$disabled?"none":"auto"};
  cursor: ${e=>e.$disabled?"not-allowed":"pointer"};

  &:active,
  &:focus {
    color: ${e=>e.theme.palette.PRIMARY_FOCUS};
    text-decoration-color: ${e=>e.theme.palette.PRIMARY_FOCUS};

    .arrow-line,
    .arrow-pointer {
      fill: ${e=>e.theme.palette.PRIMARY_FOCUS};
    }
  }

  :hover {
    svg.anchor-arrow {
      margin-left: ${e=>e.theme.measurements.spacing(3.25)};
    }

    path.arrow-line {
      d: path(
        'M0.5 5.5C0.5 5.08579 0.787817 4.75 1.14286 4.75H8.85714C9.21218 4.75 9.5 5.08579 9.5 5.5C9.5 5.91421 9.21218 6.25 8.85714 6.25H1.14286C0.787817 6.25 0.5 5.91421 0.5 5.5Z'
      );
    }
  }
`,M=_styled2.default.a`
  ${m}
  color: ${e=>e.theme.palette.BASE_FILL};
  font-size: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
  line-height: ${e=>e.theme.measurements.spacing(7)};
  text-transform: uppercase;
  background: ${e=>e.theme.palette.BASE_ONE};
  border: ${e=>e.theme.measurements.shape(.25)} solid
    ${e=>e.theme.palette.DIVIDER};
  border-radius: ${e=>e.theme.measurements.shape(1.5)};
  padding: ${e=>e.theme.measurements.spacing(e.$size==="small"?4.5:6)}
    ${e=>e.theme.measurements.spacing(e.$size==="small"?6:9)};
  pointer-events: ${e=>e.$disabled?"none":"auto"};
  cursor: ${e=>e.$disabled?"not-allowed":"pointer"};

  &:hover {
    background: ${e=>e.theme.palette.BASE_ZERO};
  }

  &:active,
  &:focus {
    background: ${e=>e.theme.palette.DIVIDER};
  }
`,H=_react2.default.forwardRef((e,t)=>{let{href:s,as:d,Wrapper:h=v,newTab:p=!1,children:$,ariaLabel:u,title:g,onClick:n,dataTestId:f,className:b,disabled:a,rightArrow:l=!1,underline:A=!0,size:L="large",variant:i="primary",rel:k="noopener noreferrer"}=e,w=p?"_blank":"_self",S=i==="caps"?M:T,R=_react.useCallback.call(void 0, C=>{!n||n(C)},[n]);return _jsxruntime.jsx.call(void 0, h,{href:s,as:d,disabled:a,children:_jsxruntime.jsxs.call(void 0, S,{href:s,target:w,ref:t,title:g,"aria-label":u,"data-testid":f,onClick:!a&&n?R:void 0,className:b,$disabled:a,$underline:A&&!l,$variant:i,$size:L,rel:k,children:[_jsxruntime.jsx.call(void 0, _,{children:$}),l&&i!=="caps"?_jsxruntime.jsx.call(void 0, F,{}):""]})})}),W= exports.a =H;exports.a = W;
